import React from 'react'
import { StyleSheetManager, ThemeProvider as Provider } from 'styled-components'
import * as Goat from '@primer-io/goat-tokens'
import { above } from 'etymos'
import isPropValid from '@emotion/is-prop-valid'

import colors from './colors'
import breakpoints from './breakpoints'
import typography from './typography'
import sizes from './sizes'
import easing from './easing'

const columns = 12

const theme = {
	above,
	colors,
	breakpoints,
	typography,
	columns,
	sizes,
	easing,
}

export const ThemeProvider = ({ children }) => (
	<StyleSheetManager shouldForwardProp={isPropValid}>
		<Provider theme={{ ...theme, ...Goat }}>{children}</Provider>
	</StyleSheetManager>
)

export default theme
